import { configureStore } from '@reduxjs/toolkit'
import {
  autorizacionesApi,
  catalogosApi,
  sitiosApi,
  tareasApi,
  notificacionesApi,
  recordatoriosApi,
  reportesCumplimientoApi,
  condicionantesApi,
  usuariosApi,
} from './api'
import { autorizacionesSlice } from './slices/autorizaciones'
import { PaginaSlice } from './slices/pagina'
import { sitiosSlice } from './slices/sitios'
import { reportesSlice } from './slices/reportes'
import { calendarioApi } from './api/calendario.api'
import { tareasSlice } from './slices/tareas'
import { catalogosSlice } from './slices/catalogos'
import { perfilSlice } from './slices/perfil/perfil.slice'
import { AutenticacionSlice } from './slices/autenticacion/autenticacion.slice'
import { autenticacionApi, datosUsuarioApi } from './api/autenticacion.api'
import { baseApi } from './api/base.api'

/**
 * Store central de Redux.
 *
 * Combina estado local de UI con caches de RTK Query por dominio. Cada API
 * registrada aqui debe agregar su reducer y middleware para que sus hooks
 * generados puedan cachear, invalidar y ejecutar peticiones correctamente.
 */
export const store = configureStore({
  reducer: {
    // Estado transversal de filtros, ordenamiento y paginacion de listados.
    pagina: PaginaSlice.reducer,

    //Catalogos
    catalogo: catalogosSlice.reducer,
    [catalogosApi.reducerPath]: catalogosApi.reducer,

    //Sitios
    sitio: sitiosSlice.reducer,
    [sitiosApi.reducerPath]: sitiosApi.reducer,

    //Autorizaciones
    autorizacion: autorizacionesSlice.reducer,
    [autorizacionesApi.reducerPath]: autorizacionesApi.reducer,

    //Condicionantes
    [condicionantesApi.reducerPath]: condicionantesApi.reducer,

    //Tareas
    [tareasApi.reducerPath]: tareasApi.reducer,

    //Recordatorios
    [recordatoriosApi.reducerPath]: recordatoriosApi.reducer,

    //Reportes cumplimiento
    reportes: reportesSlice.reducer,
    [reportesCumplimientoApi.reducerPath]: reportesCumplimientoApi.reducer,

    //Calendario
    [calendarioApi.reducerPath]: calendarioApi.reducer,

    //Tareas Card tareas detall autorización
    listaTareas: tareasSlice.reducer,
    [tareasApi.reducerPath]: tareasApi.reducer,

    //Notificaciones
    [notificacionesApi.reducerPath]: notificacionesApi.reducer,

    //Usuarios
    [usuariosApi.reducerPath]: usuariosApi.reducer,

    //Perfil
    opcionesPerfil: perfilSlice.reducer,

    // Estado y cache de autenticacion: tokens, usuario actual y recuperacion de datos de `/u`.
    [autenticacionApi.reducerPath]: autenticacionApi.reducer,
    [datosUsuarioApi.reducerPath]: datosUsuarioApi.reducer,
    [baseApi.reducerPath]: baseApi.reducer,
    autenticacion: AutenticacionSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      baseApi.middleware,
      catalogosApi.middleware,
      sitiosApi.middleware,
      autorizacionesApi.middleware,
      tareasApi.middleware,
      condicionantesApi.middleware,
      recordatoriosApi.middleware,
      reportesCumplimientoApi.middleware,
      calendarioApi.middleware,
      notificacionesApi.middleware,
      usuariosApi.middleware,
      autenticacionApi.middleware,
      datosUsuarioApi.middleware,
    ]),
  devTools: true,
})

// Opcional, pero requerido para refetchOnFocus
//setupListeners(store.dispatch)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
